<div class="pt-3 pl-md-4 mb-6">

  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin">
        Admin
      </a></li>
      <li class="breadcrumb-item active" aria-current="page">
        Memberships & Passes
      </li>
    </ol>
  </nav>

  <h2 *ngIf="!accountService.getMyAccount().can_manage_members">
    You do not have permission to manage memberships.
  </h2>

  <h2 *ngIf="serverError !== null">
    Server Error: {{ serverError }}
  </h2>

  <ng-container *ngIf="accountService.getMyAccount().can_manage_members && serverError === null">

    <div class="alert" role="alert"
         [class.alert-success]="history.state.feedback.status == 'success'"
         [class.alert-info]="history.state.feedback.status == 'info'"
         *ngIf="history && history.state && history.state.feedback">
      {{ history.state.feedback.text }}
    </div>

    <div class="mb-4">

      <div class="float-right">
        <div class="dropdown">
          <button class="btn btn-primary dropdown-toggle" type="button"
                  id="membershipSettingsDropdownButton"
                  data-toggle="dropdown" aria-expanded="false">
            Membership Settings
          </button>
          <div class="dropdown-menu dropdown-menu-right"
               aria-labelledby="membershipSettingsDropdownButton">
            <a class="dropdown-item" routerLink="/membership-settings/cancellation-reason">
              Cancellation Reasons
            </a>
            <a class="dropdown-item" routerLink="/membership-settings/freeze-reason">
              Freeze Reasons
            </a>
            <a class="dropdown-item" routerLink="/membership-settings/org-wide-policies">
              Org-Wide Policies
            </a>
            <a class="dropdown-item" routerLink="/membership-settings/discounts">
              Discounts
            </a>
            <a class="dropdown-item" routerLink="/membership-settings/categories">
              Categories
            </a>
          </div>
        </div>
      </div>

      <h2>Memberships <span *ngIf="loadingMemberships" class="text-secondary">- Loading...</span></h2>

      <div class="rounded-table-wrapper table-responsive-lg">
        <table class="table">

          <thead>
          <tr>
            <th>Type</th>
            <th>Name</th>
            <th>Pricing</th>
            <th>Status</th>
            <th></th>
          </tr>
          </thead>

          <tbody *ngIf="membershipResultsPresent()">
          <tr *ngFor="let membership of membershipList.results">
            <td>
              {{ membership.is_group ? 'Group' : 'Single' }},
              {{ getMembershipPurchaseTypeDisplay(membership.purchase_type) }}{{ membership.purchase_type === MembershipPurchaseType.benefit ? '' : ',' }}
              <ng-container *ngIf="membership.purchase_type === MembershipPurchaseType.recurring">
                {{ getMembershipIntervalDisplay(membership.interval) }}
              </ng-container>
              <ng-container *ngIf="membership.purchase_type === MembershipPurchaseType.prepaid">
                <ng-container *ngIf="membership.has_fixed_date_ranges">
                  Fixed Date Ranges
                </ng-container>
                <ng-container *ngIf="!membership.has_fixed_date_ranges">
                  {{ getMembershipDurationDisplay(membership.duration_years, membership.duration_months, membership.duration_days) }}
                </ng-container>
              </ng-container>
            </td>
            <td>{{ membership.name }}</td>
            <td>
              <span *ngIf="!membership.is_group">
                <span *ngIf="membership.purchase_type === MembershipPurchaseType.recurring">
                  {{ membership.initiation_fee > 0 ? orgConfigService.formatCurrency(membership.initiation_fee) : 'No' }} initiation fee
                  <br>
                  {{ orgConfigService.formatCurrency(membership.membership_fee) }} {{ getMembershipIntervalDisplay(membership.interval).toLowerCase() }} fee
                </span>
                <span *ngIf="(membership.purchase_type === MembershipPurchaseType.prepaid) && (membership.membership_fee !== null)">
                  {{ orgConfigService.formatCurrency(membership.membership_fee) }}
                </span>
              </span>
              <span *ngIf="membership.is_group">
                <span *ngIf="membership.purchase_type === MembershipPurchaseType.recurring">
                  {{ membership.initiation_fee > 0 ? orgConfigService.formatCurrency(membership.initiation_fee) : 'No' }} initiation fee
                  <br>
                  {{ orgConfigService.formatCurrency(membership.adult_base_fee) }} {{ getMembershipIntervalDisplay(membership.interval).toLowerCase() }} base {{ membership.adult_tier_name|lowercase }} fee
                  <span *ngIf="membership.has_youth_tier">
                    <br>
                    {{ orgConfigService.formatCurrency(membership.youth_base_fee) }} {{ getMembershipIntervalDisplay(membership.interval).toLowerCase() }} base {{ membership.youth_tier_name|lowercase }} fee
                  </span>
                </span>
                <span *ngIf="membership.purchase_type === MembershipPurchaseType.prepaid">
                  {{ orgConfigService.formatCurrency(membership.adult_base_fee) }} base {{ membership.adult_tier_name }} fee
                  <span *ngIf="membership.has_youth_tier">
                    <br>
                    {{ orgConfigService.formatCurrency(membership.youth_base_fee) }} base {{ membership.youth_tier_name }} fee
                  </span>
                </span>
              </span>
            </td>
            <td [class.text-secondary]="membership.status === MembershipStatus.draft"
                [class.text-success]="membership.status === MembershipStatus.active"
                [class.text-danger]="membership.status === MembershipStatus.retired">
              {{ getMembershipStatusDisplay(membership.status) }}
            </td>
            <td class="table-btn-sm text-right">
              <a class="btn btn-sm btn-outline-primary"
                 routerLink="/memberships/{{ membership.id }}">
                Edit
              </a>
              <a class="btn btn-sm btn-outline-primary ml-1"
                 href="{{ climberAppMembershipDetailsUrl(membership) }}"
                 target="_blank">
                View
              </a>
            </td>
          </tr>
          </tbody>

          <tbody *ngIf="!membershipResultsPresent()">
          <tr>
            <td colspan="99">
              {{ loadingMemberships ? 'Loading...' : 'No memberships' }}
            </td>
          </tr>
          </tbody>

        </table>
      </div>

      <a class="btn btn-primary" routerLink="/memberships/add">
        Add Membership
      </a>

    </div>

    <div class="mb-4">

      <div class="float-right">
        <div class="dropdown">
          <button class="btn btn-primary dropdown-toggle" type="button"
                  id="entryPassSettingsDropdownButton"
                  data-toggle="dropdown" aria-expanded="false">
            Entry Pass Settings
          </button>
          <div class="dropdown-menu dropdown-menu-right"
               aria-labelledby="entryPassSettingsDropdownButton">
            <a class="dropdown-item" routerLink="/entry-pass-settings/discounts">
              Discounts
            </a>
          </div>
        </div>
      </div>

      <h2>Entry Passes <span *ngIf="loadingEntryPasses" class="text-secondary">- Loading...</span></h2>

      <div class="rounded-table-wrapper table-responsive-lg">
        <table class="table">

          <thead>
          <tr>
            <th>Name</th>
            <th>Num Passes</th>
            <th>Price</th>
            <th>Status</th>
            <th></th>
          </tr>
          </thead>

          <tbody *ngIf="entryPassResultsPresent()">
          <tr *ngFor="let entryPass of entryPassList.results">
            <td>{{ entryPass.name }}</td>
            <td>{{ entryPass.num_passes }}</td>
            <td>{{ orgConfigService.formatCurrency(entryPass.price) }}</td>
            <td [class.text-secondary]="entryPass.status === EntryPassStatus.draft"
                [class.text-success]="entryPass.status === EntryPassStatus.active"
                [class.text-danger]="entryPass.status === EntryPassStatus.retired">
              {{ getEntryPassStatusDisplay(entryPass.status) }}
            </td>
            <td class="table-btn-sm text-right">
              <a class="btn btn-sm btn-outline-primary"
                 routerLink="/entry-passes/{{ entryPass.id }}">
                Edit
              </a>
              <a class="btn btn-sm btn-outline-primary ml-1"
                 href="{{ climberAppEntryPassDetailsUrl(entryPass) }}"
                 target="_blank">
                View
              </a>
            </td>
          </tr>
          </tbody>

          <tbody *ngIf="!entryPassResultsPresent()">
          <tr>
            <td colspan="99">
              {{ loadingEntryPasses ? 'Loading...' : 'No passes' }}
            </td>
          </tr>
          </tbody>

        </table>
      </div>

      <a class="btn btn-primary" routerLink="/entry-passes/add">
        Add Pass
      </a>

    </div>

  </ng-container>

</div>
